import { useMemo } from 'react';

import { useFetchScoutPlayerProfiles } from './fetch-scout-players-profiles';

export const useFetchPlayersProfile = (playerData = {}) => {
    const playerIds = useMemo(() => playerData?.favItems?.map(({ itemEntityId }) => itemEntityId).filter(Boolean), [
        playerData?.favItems
    ]);

    const { orderedProfiles, processing } = useFetchScoutPlayerProfiles(playerIds);

    return { allFavoritePlayers: orderedProfiles, isProcessing: processing };
};
